import React, { Component } from 'react';
import QrReader from 'react-qr-reader';
import { withRouter } from 'react-router-dom';
import QRQinectAPI from '../QRQinectAPI';


class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
            goButtonText: "VIEW",
            delay: 500,
            result: 'Please scan a QR code to continue',
            showGo: false,
            protocol: 'https://',
            url: 'qr.saymore.net/',
            showScanner: true,
            token: null
        }
        this.handleScan = this.handleScan.bind(this);
        this.scanAnother = this.scanAnother.bind(this);
    }
    componentDidMount() {
        // was a token passed?
        // if so, we should skip the login and go directly to adding a video on scan
        let passedToken = window.location.search.split("token=")[1];
        let newButtonText = this.state.goButtonText;
        if (passedToken) {
            newButtonText = "ADD A MESSAGE TO THIS CODE";
        }
        this.setState({ token: passedToken, goButtonText: newButtonText });
    }
    handleScan(data) {
        if (data) {
            let showGo = false;
            let protocol = this.state.protocol;
            if (data.indexOf("qr.saymore.net") !== -1) {
                showGo = true;
                // do we need to pre-pend https?
                if (data.indexOf("https://") !== -1) {
                    // if we found the https protocol, we don't need to pre-pend it
                    protocol = "";
                }
            }
            this.setState({
                result: data,
                showGo: showGo,
                protocol: protocol,
                url: data
            });
        }
    }
    handleError(err) {
        console.log(err);
    }
    handleURLChange(event) {
        this.setState({ url: event.target.value });
    }
    goToURL = () => {

        // if we have a token && this is a qr code url
        let qrCode = this.state.url.split("/").pop();

        if (this.state.token && qrCode !== "") {
            QRQinectAPI.loginBuyer(this.state.token, "", "", "", "", "", "", qrCode)
                .then((response) => {
                    //update the Index state with the Buyer
                    this.props.updateState({ Buyer: response.data, QRCode: qrCode });
                    window.location.assign('scan/' + qrCode + '/video/' + this.state.token);
                    // this.props.history.push({
                    //     pathname: 'scan/' + qrCode + '/video/' + this.state.token,
                    //     state: { Buyer: response.data }
                    // });
                })
                .catch((error) => {
                    console.log(error);
                    let errorMessage = error.toString();
                    if (error.response && error.response.data) {
                        errorMessage = error.response.data;
                    }
                    this.setState({ error: true, errorMessage: errorMessage });
                });
        } else {
            let protocol = '';
            if (this.state.url.indexOf("//") === -1) {
                protocol = '//';
            }
            window.location.assign(protocol + this.state.url);
        }
    }
    scanAnother() {
        this.setState({
            showGo: false,
            result: 'Please scan a QR code to continue'
        });
    }
    renderGoButton() {
        if (this.state.showGo) {
            return (
                <React.Fragment>
                    <p>{this.state.result}</p>
                    <a className="button" style={{ paddingTop: '24px', paddingBottom: '24px' }} onClick={this.goToURL} /*href={this.state.protocol + this.state.result}*/>{this.state.goButtonText}</a>
                    <a className="button" style={{ paddingTop: '24px', paddingBottom: '24px', backgroundColor: '#666', cursor: 'pointer' }} onClick={this.scanAnother}>SCAN ANOTHER CODE</a>
                </React.Fragment>
            );
        }
    }
    renderReader() {
        if (this.state.showGo) {
            return null;
        } else if (this.state.showScanner) {
            return (
                <React.Fragment>
                    <div style={{ textAlign: 'center' }}>
                        <p>Please place your QR code within the viewer to begin.</p>
                        <div>Having trouble scanning? Try moving your device closer to/farther from the code.</div>
                    </div>
                    <QrReader
                        delay={this.state.delay}
                        onError={this.handleError}
                        onScan={this.handleScan}
                        style={{ width: '100%' }}
                    />
                    <p>{this.state.result}</p>
                    <div style={{ textAlign: 'center' }}>
                        <div className="secondaryColor" style={{ cursor: 'pointer' }} onClick={() => { this.setState({ showScanner: false }) }}>
                            <span className="fa-stack" style={{ position: 'relative' }}>
                                <i className="fa fa-camera fa-stack-1x" style={{ position: 'absolute', fontSize: 'small' }}></i>
                                <i className="fa fa-ban fa-stack-2x " ></i>
                            </span> <span style={{ textDecoration: 'underline' }}>Don't Have a Camera?</span>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return (
                <div style={{ textAlign: 'center' }}>
                    <div>Enter the URL from the back of your card below.</div>
                    <input type="text" value={this.state.url} onChange={event => this.handleURLChange(event)}></input><a className="button" style={{ paddingTop: '24px', paddingBottom: '24px' }} onClick={this.goToURL}>{this.state.goButtonText}</a>
                    <div className="secondaryColor" style={{ cursor: 'pointer' }} onClick={() => { this.setState({ showScanner: true }) }}>
                        <span className="fa-stack" style={{ position: 'relative' }}>
                            <i className="fa fa-camera fa-stack-1x" style={{ position: 'absolute' }}></i>
                            <i className="fa fa-stack-2x " ></i>
                        </span> <span style={{ textDecoration: 'underline' }}>Use Camera</span>
                    </div>
                </div>
            );
        }
    }
    render() {
        return (
            <div>
                <div className="login_register">
                    <div className="container">
                        <div className="entry">
                            <div className="head">
                                <div className="logoImage"></div>

                                {this.renderGoButton()}
                                {this.renderReader()}
                                {/* <QrReader
                                    delay={this.state.delay}
                                    onError={this.handleError}
                                    onScan={this.handleScan}
                                    style={{ width: '100%' }}
                                /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js